import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import trackingService from '../services/tracking';

// Paths handled by their own components — skip to avoid double-counting
const SELF_TRACKED_PREFIXES = ['/view/audio/', '/view/video/', '/view/image/'];

const usePageTracking = () => {
    const location = useLocation();
    const lastPath = useRef(null);
    const lastTime = useRef(0);

    useEffect(() => {
        const path = location.pathname;
        const now = Date.now();

        // Debounce: same path within 3 seconds = React re-render, not real navigation
        if (path === lastPath.current && now - lastTime.current < 3000) return;

        // Skip media viewer pages — they call trackPageView themselves
        if (SELF_TRACKED_PREFIXES.some(p => path.startsWith(p))) return;

        lastPath.current = path;
        lastTime.current = now;

        // Profile pages get type 'profile' so view_count increments correctly
        const profileMatch = path.match(/^\/profile\/([^/]+)$/);
        if (profileMatch) {
            trackingService.trackPageView('profile', profileMatch[1]);
        } else {
            trackingService.trackPageView('other', path);
        }
    }, [location.pathname]);
};

export default usePageTracking;
